import { Controller } from "@hotwired/stimulus"

// Progressive disclosure for the storefront's secondary filters. The trigger is
// a pill sitting at the end of the category chip row; the panel it opens spans
// the full width underneath — which is why this isn't a plain <details>, whose
// summary and content can't be laid out independently of each other.
export default class extends Controller {
  static targets = ["panel", "trigger", "caret"]

  // Starts open when a secondary filter is already applied, so an active
  // filter is never hidden behind a collapsed pill.
  static values = { open: Boolean }

  connect() {
    this.apply()
  }

  toggle() {
    this.openValue = !this.openValue
    this.apply()
  }

  apply() {
    this.panelTarget.classList.toggle("hidden", !this.openValue)
    this.triggerTarget.setAttribute("aria-expanded", String(this.openValue))

    this.triggerTarget.classList.toggle("bg-brand-soft", this.openValue)
    this.triggerTarget.classList.toggle("text-brand", this.openValue)
    this.triggerTarget.classList.toggle("border-brand", this.openValue)
    this.triggerTarget.classList.toggle("bg-white", !this.openValue)
    this.triggerTarget.classList.toggle("text-muted", !this.openValue)
    this.triggerTarget.classList.toggle("border-line", !this.openValue)

    if (this.hasCaretTarget) {
      this.caretTarget.classList.toggle("rotate-180", this.openValue)
    }
  }
}
